import React from 'react';
import { LINKS } from '../lib/links';
import { FadeIn } from './FadeIn';
import { MapPin, ArrowUpRight } from 'lucide-react';
export function Location() {
  return <section id="location" className="py-20 md:py-32 px-6 md:px-12 bg-cream relative scroll-mt-16" data-id="element-142">
      <div className="max-w-6xl mx-auto" data-id="element-143">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-144">
          {/* Sunset image */}
          <div className="order-2 md:order-1" data-id="element-145">
            <FadeIn data-id="element-146">
              <div className="aspect-[4/3] w-full overflow-hidden rounded-sm" data-id="element-147">
                <img src="https://cdn.magicpatterns.com/uploads/6Ew4gLtza9LmKtNg4QjtwM/472670554_122134502420570946_2241759590050120448_n.jpg" alt="Sunrise over the open fields beside Pines Retreat" className="w-full h-full object-cover" data-id="element-148" />
              </div>
            </FadeIn>
          </div>

          {/* Text + actions */}
          <div className="order-1 md:order-2" data-id="element-149">
            <FadeIn data-id="element-150">
              <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-4" data-id="element-151">
                The Location
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-152">
              <h2 className="font-serif text-3xl md:text-4xl text-pine mb-6 leading-tight" data-id="element-153">
                Near Pardes Hanna
                <br data-id="element-154" />/ Kfar Pines.
              </h2>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-155">
              <p className="text-lg text-clay font-light leading-relaxed mb-4" data-id="element-156">
                Tucked away in nature, a short drive from Tel Aviv and Haifa. A
                hidden space designed for dropping in and slowing down.
              </p>
            </FadeIn>
            <FadeIn delay={0.25} data-id="element-157">
              <p className="text-sm text-clay/70 mb-10" data-id="element-158">
                ~45 min from Tel Aviv · ~30 min from Haifa
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-159">
              <a href={LINKS.googleMaps} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-3 px-6 py-3.5 bg-pine text-cream rounded-sm font-medium tracking-wide hover:bg-pineDeep transition-colors" data-id="element-160">
                <MapPin className="w-4 h-4" data-id="element-161" />
                Get Directions
                <ArrowUpRight className="w-4 h-4 opacity-70 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-162" />
              </a>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}